import router from './outbox.router'

export default {
  router,
}
